// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Resources } from "../../../Commons/properties/Resources.js";

//
// Constructor
//
//#region
export let QuickTableColumn = function ()
{

    // main
    this.width = 100;
    this.headerText = 'Header';
    this.visible = true;
    this.hidden = false;
    this.allowSorting = true;
    this.allowGrouping = false
    this.displayedIndex = 1;
    this.sortRule = QuickTableColumn.SortRuleType.Text;
    this.aligment = QuickTableColumn.Aligment.Center;

    // Colors
    this.BackColor = null;
    this.color = null;
    this.ForeColor = null;

    this.beginGroup = false;
    this.MenuIndex = 1000;

    //
    // Private fields (прячем в специальном объекте)
    //
    this.PRIVATE = {};

    this.PRIVATE.drawingWidth = 0;
    this.PRIVATE.drawingX = 0;

    this.ColouringMode = ColouringModes.None;
    this.ValueUpBackColor = null;
    this.ValueUpForeColor = null;
    this.ValueDownBackColor = null;
    this.ValueDownForeColor = null;
}
//#endregion

QuickTableColumn.prototype.setParameters = function (columnParams)
{

    this.headerText = Resources.getResource(columnParams.headerKey);
    this.headerKey = columnParams.headerKey;
    this.visible = columnParams.visible;
    this.hidden = columnParams.hidden;
    this.allowGrouping = columnParams.allowGrouping;
    this.sortIndex = columnParams.sortIndex;
    this.displayedIndex = columnParams.sortIndex;
    this.width = columnParams.width;

    //this.sortRule = columnParams.sortRule;
    this.beginGroup = columnParams.beginGroup;
    this.MenuIndex = columnParams.MenuIndex;

    var tooltipKey = this.headerKey + '.descr';
    this.tooltipKey = Resources.IsResourcePresent(tooltipKey) ?
        tooltipKey : this.headerKey;
};

export let ColouringModes =
{
    None: 0,
    Previous: 1,
    Signed: 2
};

//
// Enums
//
QuickTableColumn.SortRuleType =
{
    Text: 1,
    Numeric: 2,
    Data: 3
};
Object.freeze(QuickTableColumn.SortRuleType);

QuickTableColumn.Aligment =
{
    Left: 'Left',
    Center: 'Center',
    Right: 'Right'
};
// deny modifying
Object.freeze(QuickTableColumn.Aligment);